<script lang="ts" setup>
import { ref } from 'vue';

interface Props {
  title?: string;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'click-description', counter: number, ev: Event): void;
}>();

const counter = ref(0);

function onClickDescription(ev: Event) {
  counter.value++;

  emit('click-description', counter.value, ev);
}

defineExpose({
  counter,
  testExpose: {
    message: 'Просто пример экспортируемого значения из компонента'
  },
});
</script>

<template>
  <section class="c-dev-example">
    <h3 class="c-title" v-if="title">
      {{ title }}
    </h3>

    <p class="c-description">
      Это тестовый Vue компонент! <br>
      Предназначен, для проверки работы компонента внутри Angular окружения

      <button type="button" @click.prevent="onClickDescription">
        Кликов - {{ counter }}
      </button>
    </p>

    <div class="c-inner-content">
      <slot>
        Компонент, без вложенного контента
      </slot>
    </div>
  </section>
</template>

<style lang="scss">
.c-dev-example {
  padding: 20px;
  margin: 0;
  background: rgba(98, 224, 100, 0.2);
  border-radius: 16px;
  color: rgb(69, 174, 70);
}

.c-title {
  font-weight: 500;
  font-size: 18px;
  margin: 0 0 16px;
  padding: 0;
  color: inherit;
}

.c-description {
  font-weight: 400;
  font-size: 16px;
}

.c-inner-content {
  font-size: 14px;
  opacity: 0.7;
  font-style: italic;
  border-radius: 6px;
  border: 1px dashed currentColor;
  padding: 8px;
}
</style>